import { render } from "./douyinaccount.vue?vue&type=template&id=2d9be7bc&scoped=true"
import script from "./douyinaccount.vue?vue&type=script&lang=js"
export * from "./douyinaccount.vue?vue&type=script&lang=js"

import "./douyinaccount.vue?vue&type=style&index=0&id=2d9be7bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d9be7bc"]])

export default __exports__